import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import ScanStep from "./ScanStep";
import CreateStopsStep from "./CreateStopsStep";
import SplitStopsStep from "./SplitStopsStep";
import OptimizeRouteStep from "./OptimizeRouteStep";
import { resetRouteFlow, setCurrentStep, nextStep, previousStep, setDeliveryId } from "../../../redux/routeFLowSlice";
import styles from "./RouteFlowDialog.module.scss";

function RouteFlowDialog({ visible, onHide, deliveryId }) {
    const dispatch = useDispatch();
    const currentStep = useSelector((state) => state?.routeFlowSlice?.currentStep);
    console.log("Current Step from Store:", currentStep);

    const steps = [{ label: "Scan Packages" }, { label: "Create Stops" }, { label: "Split Stops" }, { label: "Optimize Route" }];

    useEffect(() => {
        if (visible) {
            dispatch(resetRouteFlow());
            dispatch(setDeliveryId(deliveryId));
        }
    }, [visible, dispatch, deliveryId]);

    const handleClose = () => {
        dispatch(resetRouteFlow());
        onHide();
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return <ScanStep deliveryId={deliveryId} />;
            case 2:
                return <CreateStopsStep deliveryId={deliveryId} />;
            case 3:
                return <SplitStopsStep deliveryId={deliveryId} />;
            case 4:
                return <OptimizeRouteStep deliveryId={deliveryId} onComplete={handleClose} />;
            default:
                return null;
        }
    };

    return (
        <Dialog visible={visible} onHide={handleClose} header="Delivery Route Flow" modal className={styles.routeFlowDialog} style={{ width: "90vw", maxWidth: "1200px" }} maximizable>
            <div className={styles.dialogContent}>
                {/* Steps Header */}
                <div className={styles.stepsContainer}>
                    <Steps model={steps} activeIndex={currentStep - 1} readOnly={false} className={styles.steps} />
                </div>

                {/* Step Content */}
                <div className={styles.stepContent}>{renderStepContent()}</div>
            </div>
        </Dialog>
    );
}

export default RouteFlowDialog;
